import { render, staticRenderFns } from "./TradeShowPhotosDisplay.vue?vue&type=template&id=3f6b8fd6&scoped=true&"
import script from "./TradeShowPhotosDisplay.vue?vue&type=script&lang=js&"
export * from "./TradeShowPhotosDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TradeShowPhotosDisplay.vue?vue&type=style&index=0&id=3f6b8fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b8fd6",
  null
  
)

export default component.exports